gl-address-search {
  display: flex;
  flex-direction: column;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1000;
  max-height: 100%;
}
gl-address-search ion-searchbar {
  flex: none;
}
gl-address-search ion-list.list-md {
  margin-bottom: 0;
  overflow-y: scroll;
}
